<!--
 * @Author: Jason
 * @Date: 2019-10-15 17:32:50
 * @version:
 * @LastEditors: Jason
 * @LastEditTime: 2020-04-21 15:44:14
 * @Descripttion:
 -->
<template>
  <div :class="{ fixed: isShow }">
    <mask-box :isShow.sync="isShow" :contentImg="contentImg"></mask-box>
    <div class="flex-btwn-aic header">
      <div class="index-loc hidden"></div>
      <div></div>
      <div class="flex-jce-aic index-loc" @click="toRouter('/personal')">
        <img src="../assets/imgs/icon_person.png" alt />
      </div>
    </div>
    <div class="mt">
      <img src="../assets/imgs/index_banner.png" width="100%" alt />
    </div>
    <div class="flex-btwn-aic activity-info">
      <div>剩余名额：{{ remainNum }}</div>
      <div>活动结束日期：2023-10-31</div>
      <!-- 剩余可用次数：{{remainNum}} -->
    </div>
    <div class="index-btn-list">
      <!-- <div class="index-btn-item flex-aic flex-wrap public-btn bg" @click="toRouter('/service')">
        <div class="index-btn-item-title">立即兑换</div>
        <div class="index-btn-item-tip">（18项安全检测含车身洁净）</div>
      </div>-->
      <div class="mt-52 public-btn bg" @click="toRouter('/service/pay')">
        1元洗车
      </div>
      <div class="mt-52 public-btn border" @click="toRouter('/shop/city')">
        门店查询
      </div>
      <div class="mt-52 public-btn border" @click="toRouter('/order')">
        我的订单
      </div>
      <div class="mt-52 public-btn border" @click="toRule">
        服务细则
      </div>
    </div>
    <img
      style="padding: 20px;"
      src="../assets/imgs/index_sysm.png"
      alt="sysm"
    />
    <!-- 规则 -->
    <!-- <div class="index-rule">
      <img src="../assets/imgs/index_title_info.png" alt />
      <div class="index-rule-list">
        <div class="index-rule-item">1、活动时间：即日起至2023年10月31日；</div>
        <div class="index-rule-item">2、活动对象：农行晋通ETC信用卡持卡人；</div>
        <div class="index-rule-item">3、收到洗车活动短信通知的客户，可关注“盛世大联汽车”微信公众号-“优惠活动”-“山西农行1元洗车”，支付1元，可领一张洗车券；</div>
        <div class="index-rule-item">4、晋通ETC信用卡客户当月累计消费满500元，次月可享1次“1元洗车”优惠权益；当月累计消费满1000元，次月可享2次；当月首次签约ETC业务，次月亦可获赠1次。每卡每月至多可享3次“1元洗车”优惠权益。数量有限，先购先得。洗车券为省内通用券，可通过查询前去服务门店，并展示服务二维码享受该服务。</div>
        <div class="index-rule-item">5、洗车券服务有效期自购买日起30天，成功购买的洗车券可在活动页面中“我的订单”中查看，活动门店验证后方可享受服务，无需预约；</div>
        <div class="index-rule-item">6、活动参与车辆限七座（含）以下非营运车辆使用，7座以上车辆需额外加收费用，具体费用标准以各网点实际情况为准，本次活动优惠不与商户店内其它优惠、促销、赠券同时享受；</div>
        <div class="index-rule-item">7、本活动适用于上海盛世大联汽车服务股份有限公司山西地区所有洗车服务合作门店，可在活动页面直接查询服务门店，如有门店搬迁、关闭等变更情况，银行不再另行通知持卡人；</div>
        <div class="index-rule-item">8、本活动优惠权益由上海盛世大联汽车服务股份有限公司提供并全权负责，如遇问题，请致电盛大汽车服务热线：<span class="color-blue" @click="toTel('4008881768')">400-888-1768</span>。</div>
      </div>
    </div> -->
    <titleDialog  :isTitleShow.sync="isTitleShow"></titleDialog>

  </div>
</template>

<script>
import maskBox from "@/components/maskBox.vue";
import titleDialog from '@/components/titleDialog.vue'
import { GetQueryString, ls, ISWX } from "@/assets/js/utils.js";
import { GetRemanentNum } from "@/api/user.js";
export default {
  components: {
    maskBox,
    titleDialog
  },
  name: "home",
  data() {
    return {
      remainNum: 0,
      contentImg: require("@/assets/imgs/img_guoqing.png"), //国庆图片
      isShow: true, //图片显示隐藏
      isTitleShow:true,
    };
  },
  mounted() {
    console.log("当前地址链接=====>", window.location.href);
    document.body.style.backgroundColor = "#F4F5F7";
    if (ISWX()) {
      let code = GetQueryString("code");
      var local = window.location.href+'?time=' + new Date().getTime(); //测试
      // var local = "https://h5.schengle.com/ShengDaSXNHETCFW/home?time=" + new Date().getTime(); //生产
      if (code == null || code == "") {
        // window.location.href = "http://sd.auto1768.com/ShengDaAutoUnionPay/gaindAuthoriCode?redirect_uri="+encodeURIComponent(local);
        // window.location.href = "https://h5-test.schengle.com/ShengDaPAY/wechat/getAuthorizeCode?redirectUrl=" + encodeURIComponent(local);//测试地址
        window.location.href = "https://h5.schengle.com/ShengDaPAY/wechat/getAuthorizeCode?redirectUrl=" +  encodeURIComponent(local); //生产
      } else {
        sessionStorage.wxCode = code;
      }
    }
  },
  created() {
    let _ = this;

    _.getRemainNum();
    if (localStorage.getItem('dialogDate')) {
        let dialogDate = localStorage.getItem('dialogDate')
        _.isTitleShow = Math.round(new Date()) > dialogDate
    }else{
        _.isTitleShow = true
    }
    const startT = "2021/10/01 00:00:00"
    const endT = "2021/10/08 00:00:00"
    // alert(new Date(endT).getTime())
    if (
      Math.round(new Date()) >  Math.round(new Date(endT).getTime()) ||
      Math.round(new Date()) <
        Math.round(new Date(startT).getTime())
    ) {
      _.isShow = false;
    } else {
      _.isShow = true;
    }
  },
  methods: {
    toRouter(val) {
      let _ = this;
      _.$router.push(val);
    },
    toRule(){
      this.$router.push({
        path:'/fwxz',
        query:this.$route.query
      })
    },
    toTel(tel) {
      window.location.href = `tel:${tel}`;
    },
    getRemainNum() {
      let _ = this;

      GetRemanentNum({ token: ls.getter("loginStatus") })
        .then((res) => {
          // _.remainNum = res.equityNum ? res.equityNum : 0;
          _.remainNum = res.num ? res.num : 0;
        })
        .catch((err) => {
          if (err && err.resultDes) {
            _.toast(err.resultDes);
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.msg-tip {
  color: #c7c7c7;
  font-size: 3.2vw;
  margin-top: 1vw;
}

.header {
  .index-loc {
    width: 20%;
    text-align: right;
    img {
      width: 6vw;
      display: inline-block;
    }
    span {
      font-size: 3.6vw;
      text-align: left;
      flex: 1;
      -ms-flex: 1;
      -moz-flex: 1;
      -webkit-flex: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
.activity-info {
  width: 100%;
  height: 12vw;
  background-color: #fff;
  padding: 0 4vw;
  font-size: 4vw;
}
.index-btn-list {
  padding: 0 4vw 4vw;
  .mt-52 {
    margin-top: 6.9333vw;
  }
  .index-btn-item {
    line-height: normal;
    padding: 2vw 0;
    .index-btn-item-title {
      width: 100%;
    }
    .index-btn-item-tip {
      width: 100%;
      font-weight: normal;
      font-size: 2.6667vw;
    }
  }
}
</style>
